export default "__VITE_ASSET__hmLfWhQM__"